module.exports = __webpack_public_path__ + "static/BlueBackgroundA-94f3b671d962e4b93f1dee737d401868.png";